"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VSearchSelectFieldAsyncItems = void 0;
var react_1 = __importStar(require("react"));
var VSearchSelectFieldAsyncContext_1 = require("./context/VSearchSelectFieldAsyncContext");
var VSearchSelectAsyncInput_1 = require("./VSearchSelectAsyncInput");
var VSearchSelectAsyncSection_1 = require("./VSearchSelectAsyncSection");
var VSearchSelectFieldAsyncItems = function (_a) {
    var id = _a.id, multi = _a.multi, allowEmpty = _a.allowEmpty, popoverWidth = _a.popoverWidth, placeholderSearch = _a.placeholderSearch, suppessLeftIconSearch = _a.suppessLeftIconSearch;
    var refInputSearch = (0, react_1.useContext)(VSearchSelectFieldAsyncContext_1.VSearchSelectFieldAsyncContext).refInputSearch;
    return (react_1.default.createElement("div", { style: { width: "".concat(popoverWidth ? "".concat(popoverWidth, "px") : '100%') } },
        react_1.default.createElement(VSearchSelectAsyncInput_1.VSearchSelectAsyncInput, __assign({}, { id: id }, { ref: refInputSearch, fill: !!popoverWidth, placeholder: placeholderSearch, suppessLeftIcon: suppessLeftIconSearch })),
        react_1.default.createElement(VSearchSelectAsyncSection_1.VSearchSelectAsyncSection, __assign({}, { id: id, multi: multi, allowEmpty: allowEmpty }))));
};
exports.VSearchSelectFieldAsyncItems = VSearchSelectFieldAsyncItems;
